import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "@cds/core/button/register.js";
import "@cds/core/icon/register.js";
import "@cds/core/dropdown/register.js";
import "@cds/core/divider/register.js";
import "@webcomponents/custom-elements/custom-elements.min.js";
import "@clr/icons/clr-icons.min.css";
import "@clr/icons/shapes/technology-shapes.js";
import "../App.css";
import "./Home.css";

const stripHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return div.textContent || div.innerText || "";
};

const truncateContent = (content, maxLength = 200) => {
  const strippedContent = stripHtml(content);
  if (strippedContent.length > maxLength) {
    return strippedContent.substring(0, maxLength) + "...";
  }
  return strippedContent || "Article content unavailable";
};

function Home() {
  const [news, setNews] = useState([]);


  // Particle effect for the background

  useEffect(() => {
    const createParticle = () => {
      const particle = document.createElement('div');
      particle.className = 'particle';

      // Larger size range for more variety
      const size = Math.random() * 15 + 5;
      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;

      // Random position across the full viewport
      particle.style.left = `${Math.random() * 100}vw`;
      particle.style.top = `${Math.random() * 100}vh`;

      // Varied animation duration
      particle.style.animationDuration = `${Math.random() * 6 + 6}s`;

      document.querySelector('.container').appendChild(particle);

      // Remove particle after animation
      setTimeout(() => {
        particle.remove();
      }, 12000);
    };

    // Create new particles more frequently
    const interval = setInterval(() => {
      if (document.querySelector('.container')) {
        createParticle();
      }
    }, 400);  // Increased frequency

    // More initial particles
    for (let i = 0; i < 25; i++) {  // Increased initial count
      createParticle();
    }

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    const fetchNews = async () => {
      try {
        // Always provide mock data for static deployment
        if (process.env.REACT_APP_API_MOCK === 'true') {
          // Return mock data when no backend is available
          setNews([
            {
              id: 1,
              title: "Lesto Project Website Launch",
              content: "<p>The Lesto project website is now online check back soon for more content and news</p>",
              image_url: "https://www.codelikethewind.org/content/images/size/w2000/2022/05/hello_world.png",
              created_at: new Date().toISOString()
            },
          ]);
          return;
        }

        // This won't execute in static deployment
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL || ''}/api/news`);
        setNews(response.data);
      } catch (error) {
        console.error("Error fetching news:", error);
        // Fallback to mock data on error
        setNews([
          {
            id: 1,
            title: "Lesto Project Website Launch",
            content: "<p>The Lesto project website is now online check back soon for more content and news</p>",
            image_url: "https://www.codelikethewind.org/content/images/size/w2000/2022/05/hello_world.png",
            created_at: new Date().toISOString()
          }
        ]);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="container">
      <div className="container mx-auto px-4 py-8">
        <div className="min-h-screen">
          <main className="max-w-4xl mx-auto">
            <h1 className="hero-title fade-in-left text-white font-bold mb-6">
              Lead Fast Reactor Safety Design and Tools
            </h1>

            <section style={{ borderBottomRightRadius: "1.0rem", marginTop: "10vh" }} className="bg-white shadow-md p-6">
              <div>
                <p className="text-left text-gray-700 leading-relaxed space-y-4" id="blacktext">
                  The EU-funded LESTO project aims to further develop LFR technology, advancing it along its established roadmap and demonstrating its safety, efficiency, integration and reliability by employing the most relevant experimental facilities and providing a validation platform for numerical simulation tools.
                </p>

                {/* Project Key Information Box */}
                <div className="mt-6 p-4 bg-blue-50 rounded-lg border-l-4 shadow-lg border-blue-500">
                  <div className="grid grid-cols-1 md:grid-cols-2 text-left gap-4 text-sm">
                    <div>
                      <p className="font-semibold text-gray-800">Programme:</p>
                      <p className="text-gray-700">Horizon Europe – EURATOM 2027</p>
                      <p className="text-gray-600 text-xs">Safety of advanced and innovative nuclear designs</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Grant Agreement:</p>
                      <p className="text-gray-700">No 101166337</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Duration:</p>
                      <p className="text-gray-700">4 years (until October 2028)</p>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">EU Contribution:</p>
                      <p className="text-gray-700">~ 4 M€</p>
                    </div>
                    <div className="md:col-span-2">
                      <p className="font-semibold text-gray-800">Project Coordinator:</p>
                      <p className="text-gray-700">ENEA</p>
                      <p className="text-gray-600 text-xs">Main contact: Simone Gianfelici – simone.gianfelici@enea.it</p>
                    </div>

                  </div>
                </div>

                <div className="mt-6">
                  <p className="text-gray-700 leading-relaxed">
                    Lead Fast Reactors (LFRs) are a crucial technology for advancing both hydrogen energy and nuclear power solutions. The project focuses on safety features and passive safety systems, working in synergy with other EU LFR projects including HARMONISE, PATRICIA, ANSELMUS, PASCAL, INNUMAT, and PUMMA.
                  </p>
                </div>
              </div>
              <section className="mt-10">
                <h2 id="blacktext" className="text-2xl font-bold text-gray-800 mb-6">
                  Latest News
                </h2>
                {Array.isArray(news) && news.length > 0 ? (
                  <div className="space-y-6">
                    {news.map((article) => (
                      <Link
                        key={article.id}
                        to={`/news/${article.id}`}
                        className="news-article-link block bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-200 text-gray-800"
                      >
                        {article.image_url && (
                          <img
                            src={article.image_url}
                            alt={article.title || "News image"}
                            className="w-full h-64 object-cover"
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        )}
                        <div
                          className="p-6"
                          style={{ fontFamily: "Barlow, sans-serif" }}
                        >
                          <h3 className="text-xl font-bold mb-2">
                            {article.title}
                          </h3>
                          <p
                            className="mb-4"
                            style={{
                              fontSize: "12px",
                              lineHeight: "1.5",
                              color: "#333",
                              overflowWrap: "break-word",
                              wordBreak: "break-word",
                            }}
                          >
                            {truncateContent(article.content)}
                          </p>
                          <p className="text-gray-500 text-sm">
                            {new Date(article.created_at).toLocaleDateString()}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <p className="text-center text-gray-500 italic">No news available</p>
                )}
              </section>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Home;